import IdpHandler from './IdpHandler';
import { getIsSubscribed } from './utils';

// User object
export default class User {
  static isLogged() {
    return !!IdpHandler.idp?.isLogged();
  }

  static get logged() {
    return this.isLogged();
  }

  static get Data() {
    if (!this.logged) return null;

    return IdpHandler.user;
  }

  static async getToken() {
    const idp = await IdpHandler.waitIdpReady();
    return idp.getJwtToken();
  }

  static get userId() {
    if (!this.Data) return null;
    return this.Data.UID;
  }

  static get userToken() {
    return (async () => {
      const idp = await IdpHandler.waitIdpReady();
      if (!this.Data) return null;

      const result = this.Data.originalUser;
      result.token = await idp.getJwtToken();
      return JSON.stringify(result);
    })();
  }

  static get newsletters() {
    return IdpHandler.user?.subscriptions?.newsletters;
  }

  static getIsSubscribed(newsletterId?: string) {
    return getIsSubscribed(IdpHandler.user, newsletterId);
  }

  static async getFollowedClubIds() {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;
    return idp.getFollowedClubIds();
  }

  static async getFollowedTeamIds() {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;
    return idp.getFollowedTeamIds();
  }

  static async getFavouriteTeamCode() {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;
    return idp.getFavouriteTeamCode();
  }

  static async setFavouriteTeam(teamId?: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return teamId ? idp.setFavouriteTeam(teamId) : idp.removeFavouriteTeam();
  }

  static async removeFavouriteTeam() {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return idp.removeFavouriteTeam();
  }

  static async getFavouriteWomenTeam() {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;
    return idp.getFavouriteWomenTeamCode();
  }

  static async setFavouriteWomenTeam(teamId?: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return teamId ? idp.setFavouriteWomenTeam(teamId) : idp.removeFavouriteWomenTeam();
  }

  static async removeFavouriteWomenTeam() {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return idp.removeFavouriteWomenTeam();
  }

  static async getFavouriteClubId(comp?: string) {
    if (!comp) return;

    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return (await idp.getFavouriteClubId(comp)) as string;
  }

  static async setFavouriteClub(comp: string, clubId: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return idp.setFavouriteClub(comp, clubId);
  }

  static removeFavouriteClub(comp: string) {
    return this.setFavouriteClub(comp, null);
  }

  static async setFollowedClub(clubId?: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return idp.addFollowedClub(clubId);
  }

  static async setFollowedTeam(teamCode?: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return idp.addFollowedTeam(teamCode);
  }

  static async removeFollowedClub(clubId?: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return idp.removeFollowedClub(clubId);
  }

  static async removeFollowedTeam(teamCode?: string) {
    const idp = await IdpHandler.waitIdpReady();
    if (!this.logged) return;

    return idp.removeFollowedTeam(teamCode);
  }
}
